/**
 * Navigare dură către zona autentificată după login/OAuth.
 * Evită cursa în care SPA-ul citește GET /me înainte ca browserul să fi aplicat cookie-ul JWT.
 */

export function redirectToAuthenticatedAppHome(): void {
  let base = import.meta.env.BASE_URL || "/";
  if (!base.startsWith("/")) base = `/${base}`;
  if (!base.endsWith("/")) base = `${base}/`;
  window.location.assign(`${base}foi/gestiune`);
}
